import { hbs } from 'ember-cli-htmlbars';
const __COLOCATED_TEMPLATE__ = hbs("{{! @glint-nocheck: not typesafe yet }}\n<Shared::Modal @close={{@closeModal}} data-test-id=\"profile-selector-modal\" as |modal|>\n  <modal.card @portrait={{true}} class=\"cCA--profileSelector__modal\">\n    <modal.card-header data-qa-id=\"qa--profileSelector_title\">\n      <h2 class=\"o--modalHeader__title u--m__b__sm\">{{t \"calendar.schedule_to\"}}</h2>\n      <p>{{t \"calendar.profile_selector.subtitle\"}}</p>\n      <hr class=\"u--m__b__0 u--m__t__lg\" />\n    </modal.card-header>\n\n    <modal.card-body class=\"u--p__t__0\" data-qa-id=\"qa--socialProfile_modal\">\n      <Schedule::SocialProfiles::ProfileSelectorModal::SelectedProfiles\n        @selectProfile={{this.selectProfile}}\n        @temporarySelectedSocialProfiles={{this.temporarySelectedSocialProfiles}}\n      />\n\n      <Schedule::SocialProfiles::ProfileSelectorModal::Filters\n        @clearInput={{set this \"searchInput\" \"\"}}\n        @searchInput={{this.searchInput}}\n        @selectedSocialNetworks={{this.selectedSocialNetworks}}\n        @selectedSort={{this.selectedSort}}\n        @setSocialNetwork={{this.setSocialNetwork}}\n        @setSort={{this.setSort}}\n        @socialNetworkOptions={{this.socialNetworkOptions}}\n        @sortOptions={{this.sortOptions}}\n      />\n\n      <Schedule::SocialProfiles::ProfileSelectorModal::FilteredProfiles\n        @filteredSocialProfiles={{this.filteredSocialProfiles}}\n        @isProfileSelected={{this.isProfileSelected}}\n        @selectProfile={{this.selectProfile}}\n      />\n    </modal.card-body>\n\n    <modal.card-footer>\n      <Shared::Ui::Button\n        @onClick={{@closeModal}}\n        @text={{t \"shared_words.cancel\"}}\n        @variant=\"outline\"\n        data-qa-id=\"qa--profileSelector_cancel_btn\"\n      />\n      <Shared::Ui::Button\n        @isDisabled={{not this.temporarySelectedSocialProfiles.length}}\n        @onClick={{this.schedulePostToSelectedProfiles}}\n        @text={{t \"calendar.profile_selector.schedule_to_profiles\" count=this.temporarySelectedSocialProfiles.length}}\n        @variant=\"primary\"\n        class=\"u--float--right\"\n        data-qa-id=\"qa--schedulePostForProfile_btn\"\n        {{track\n          \"confirmed-calendar-profile-search\"\n          \"click\"\n          button=\"create-post\"\n          number_of_profiles=this.temporarySelectedSocialProfiles.length\n        }}\n      />\n      <Shared::Ui::Button\n        @isDisabled={{not this.temporarySelectedSocialProfiles.length}}\n        @onClick={{this.saveSelectedProfiles}}\n        @text={{t \"calendar.profile_selector.view_calendar\" count=this.temporarySelectedSocialProfiles.length}}\n        @variant=\"outline\"\n        class=\"u--float--right u--m__r__sm\"\n        data-qa-id=\"qa--viewProfileOnCalendar_btn\"\n        {{track\n          \"confirmed-calendar-profile-search\"\n          \"click\"\n          button=\"view-profile\"\n          number_of_profiles=this.temporarySelectedSocialProfiles.length\n        }}\n      />\n    </modal.card-footer>\n  </modal.card>\n</Shared::Modal>", {"contents":"{{! @glint-nocheck: not typesafe yet }}\n<Shared::Modal @close={{@closeModal}} data-test-id=\"profile-selector-modal\" as |modal|>\n  <modal.card @portrait={{true}} class=\"cCA--profileSelector__modal\">\n    <modal.card-header data-qa-id=\"qa--profileSelector_title\">\n      <h2 class=\"o--modalHeader__title u--m__b__sm\">{{t \"calendar.schedule_to\"}}</h2>\n      <p>{{t \"calendar.profile_selector.subtitle\"}}</p>\n      <hr class=\"u--m__b__0 u--m__t__lg\" />\n    </modal.card-header>\n\n    <modal.card-body class=\"u--p__t__0\" data-qa-id=\"qa--socialProfile_modal\">\n      <Schedule::SocialProfiles::ProfileSelectorModal::SelectedProfiles\n        @selectProfile={{this.selectProfile}}\n        @temporarySelectedSocialProfiles={{this.temporarySelectedSocialProfiles}}\n      />\n\n      <Schedule::SocialProfiles::ProfileSelectorModal::Filters\n        @clearInput={{set this \"searchInput\" \"\"}}\n        @searchInput={{this.searchInput}}\n        @selectedSocialNetworks={{this.selectedSocialNetworks}}\n        @selectedSort={{this.selectedSort}}\n        @setSocialNetwork={{this.setSocialNetwork}}\n        @setSort={{this.setSort}}\n        @socialNetworkOptions={{this.socialNetworkOptions}}\n        @sortOptions={{this.sortOptions}}\n      />\n\n      <Schedule::SocialProfiles::ProfileSelectorModal::FilteredProfiles\n        @filteredSocialProfiles={{this.filteredSocialProfiles}}\n        @isProfileSelected={{this.isProfileSelected}}\n        @selectProfile={{this.selectProfile}}\n      />\n    </modal.card-body>\n\n    <modal.card-footer>\n      <Shared::Ui::Button\n        @onClick={{@closeModal}}\n        @text={{t \"shared_words.cancel\"}}\n        @variant=\"outline\"\n        data-qa-id=\"qa--profileSelector_cancel_btn\"\n      />\n      <Shared::Ui::Button\n        @isDisabled={{not this.temporarySelectedSocialProfiles.length}}\n        @onClick={{this.schedulePostToSelectedProfiles}}\n        @text={{t \"calendar.profile_selector.schedule_to_profiles\" count=this.temporarySelectedSocialProfiles.length}}\n        @variant=\"primary\"\n        class=\"u--float--right\"\n        data-qa-id=\"qa--schedulePostForProfile_btn\"\n        {{track\n          \"confirmed-calendar-profile-search\"\n          \"click\"\n          button=\"create-post\"\n          number_of_profiles=this.temporarySelectedSocialProfiles.length\n        }}\n      />\n      <Shared::Ui::Button\n        @isDisabled={{not this.temporarySelectedSocialProfiles.length}}\n        @onClick={{this.saveSelectedProfiles}}\n        @text={{t \"calendar.profile_selector.view_calendar\" count=this.temporarySelectedSocialProfiles.length}}\n        @variant=\"outline\"\n        class=\"u--float--right u--m__r__sm\"\n        data-qa-id=\"qa--viewProfileOnCalendar_btn\"\n        {{track\n          \"confirmed-calendar-profile-search\"\n          \"click\"\n          button=\"view-profile\"\n          number_of_profiles=this.temporarySelectedSocialProfiles.length\n        }}\n      />\n    </modal.card-footer>\n  </modal.card>\n</Shared::Modal>","moduleName":"later/components/schedule/social-profiles/profile-selector-modal/index.hbs","parseOptions":{"srcName":"later/components/schedule/social-profiles/profile-selector-modal/index.hbs"}});
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import moment from 'moment';
import { tracked, TrackedArray } from 'tracked-built-ins';

import {
  MAX_SELECTED_SOCIAL_PROFILES_COUNT,
  ProfilePostType,
  SocialProfileType,
  TEXT_POST_TYPE
} from 'later/utils/constants';

import type RouterService from '@ember/routing/router-service';
import type IntlService from 'ember-intl/services/intl';
import type SocialProfileModel from 'later/models/social-profile';
import type AlertsService from 'later/services/alerts';
import type AuthService from 'later/services/auth';
import type SelectedSocialProfilesService from 'later/services/selected-social-profiles';
import type { EmberDropMultiSelectOption } from 'shared/components/shared/ember-drop-multi-select';

interface ProfileSelectorComponentSignature {
  Element: HTMLDivElement;
  Args: {
    closeModal: () => void;
  };
  Blocks: {
    default: [];
  };
}

interface SortOption {
  value: string;
  label: string;
}

enum SortType {
  SortBy = 'sortBy',
  Az = 'az',
  Za = 'za'
}

const SORT_BY = 'sortBy';

export default class ProfileSelectorComponent extends Component<ProfileSelectorComponentSignature> {
  @service declare alerts: AlertsService;
  @service declare auth: AuthService;
  @service declare intl: IntlService;
  @service declare router: RouterService;
  @service declare selectedSocialProfiles: SelectedSocialProfilesService;

  @tracked searchInput = '';
  @tracked selectedSocialNetworks: string[] = tracked([]);
  @tracked sort = SORT_BY;
  @tracked temporarySelectedSocialProfiles: TrackedArray<SocialProfileModel>;
  sortOptions: SortOption[];

  constructor(owner: unknown, args: ProfileSelectorComponentSignature['Args']) {
    super(owner, args);
    this.temporarySelectedSocialProfiles = new TrackedArray([...this.selectedSocialProfiles.profiles]);
    this.sortOptions = [
      { value: SortType.SortBy, label: this.intl.t('calendar.profile_selector.sort_by') },
      { value: SortType.Az, label: this.intl.t('calendar.profile_selector.az') },
      { value: SortType.Za, label: this.intl.t('calendar.profile_selector.za') }
    ];
  }

  get socialNetworkOptions(): EmberDropMultiSelectOption[] {
    const socialNetworkOptions = [
      { value: SocialProfileType.Facebook, name: this.intl.t('shared_words.facebook'), icon: 'social-facebook' },
      { value: SocialProfileType.Instagram, name: this.intl.t('shared_words.instagram'), icon: 'social-instagram' },
      { value: SocialProfileType.Linkedin, name: this.intl.t('shared_words.linkedin'), icon: 'social-linkedin' },
      { value: SocialProfileType.Pinterest, name: this.intl.t('shared_words.pinterest'), icon: 'social-pinterest' },
      { value: SocialProfileType.Threads, name: this.intl.t('shared_words.threads'), icon: 'social-threads' },
      { value: SocialProfileType.Tiktok, name: this.intl.t('shared_words.tiktok'), icon: 'social-tiktok' },
      { value: SocialProfileType.Twitter, name: this.intl.t('shared_words.twitter'), icon: 'social-twitter' },
      { value: SocialProfileType.Youtube, name: this.intl.t('shared_words.youtube'), icon: 'social-youtube' }
    ];

    if (this.auth.currentAccount?.rolloutSnapchat) {
      socialNetworkOptions.push({
        value: SocialProfileType.Snapchat,
        name: this.intl.t('shared_words.snapchat'),
        icon: 'social-snapchat'
      });
    }

    return socialNetworkOptions;
  }

  get socialProfiles(): SocialProfileModel[] {
    return this.auth.currentGroup?.socialProfiles.toArray() || [];
  }

  get filteredSocialProfiles(): SocialProfileModel[] {
    let filteredSocialProfiles = this.socialProfiles;

    if (this.searchInput) {
      filteredSocialProfiles = filteredSocialProfiles.filter((socialProfile) =>
        socialProfile.displayNickname.toLowerCase().includes(this.searchInput.toLowerCase())
      );
    }

    if (this.selectedSocialNetworks.length) {
      filteredSocialProfiles = filteredSocialProfiles.filter((socialProfile) => {
        return socialProfile.profileType && this.selectedSocialNetworks.includes(socialProfile.localizedAccountType);
      });
    }

    if (this.sort && this.sort !== SORT_BY) {
      filteredSocialProfiles = filteredSocialProfiles.sort((a, b) => {
        const nicknameA = a.nickname ?? '';
        const nicknameB = b.nickname ?? '';
        if (this.sort === SortType.Az) {
          return nicknameA.localeCompare(nicknameB);
        }
        return nicknameB.localeCompare(nicknameA);
      });
    }

    return filteredSocialProfiles;
  }
  get selectedSort(): SortOption {
    return this.sortOptions.find((sortOption) => sortOption.value === this.sort) || this.sortOptions[0];
  }

  @action
  setSocialNetwork(option: EmberDropMultiSelectOption): void {
    this.selectedSocialNetworks = this.selectedSocialNetworks.includes(option.name)
      ? tracked(this.selectedSocialNetworks.filter((selectedOption: string) => selectedOption !== option.name))
      : tracked([...this.selectedSocialNetworks, option.name]);
  }

  @action
  setSort({ value }: { value: SortOption['value'] }): void {
    this.sort = value;
  }

  @action
  selectProfile(socialProfile: SocialProfileModel): void {
    if (!this.isProfileSelected(socialProfile)) {
      if (this.temporarySelectedSocialProfiles.length >= MAX_SELECTED_SOCIAL_PROFILES_COUNT) {
        this.alerts.warning(
          this.intl.t('alerts.header.switching.multi_cal.max_profiles.message', {
            number: MAX_SELECTED_SOCIAL_PROFILES_COUNT
          }),
          { title: this.intl.t('alerts.header.switching.multi_cal.max_profiles.title') }
        );
        return;
      }

      this.temporarySelectedSocialProfiles.push(socialProfile);
    } else if (this.temporarySelectedSocialProfiles.length > 1) {
      this.temporarySelectedSocialProfiles.removeObject(socialProfile);
    }
  }

  @action
  isProfileSelected(socialProfile: SocialProfileModel): boolean {
    return Boolean(
      this.temporarySelectedSocialProfiles?.find(
        (selectedSocialProfile) => selectedSocialProfile.id === socialProfile.id
      )
    );
  }

  @action saveSelectedProfiles(): void {
    this.selectedSocialProfiles.selectExactly(this.temporarySelectedSocialProfiles);
    this.args.closeModal();
    this.selectedSocialProfiles.transition();
  }

  @action schedulePostToSelectedProfiles(): void {
    this.selectedSocialProfiles.selectExactly(this.temporarySelectedSocialProfiles);
    this.args.closeModal();

    const isListView = this.router.currentRouteName?.includes('list');
    const singleOrMultiPost =
      this.selectedSocialProfiles.profiles.length > 1 ? ProfilePostType.Multi : ProfilePostType.Single;

    const targetURL = isListView
      ? `cluster.schedule.list.post.${singleOrMultiPost}`
      : `cluster.schedule.calendar.post.${singleOrMultiPost}`;

    this.router.transitionTo(targetURL, TEXT_POST_TYPE, {
      queryParams: {
        backTo: isListView ? 'cluster.schedule.list' : 'cluster.schedule.calendar',
        scheduledTime: moment().unix()
      }
    });
  }
}
